// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["styles/gutenberg","styles/main"], function() { return __webpack_require__("./src/scripts/app.js"); })
__webpack_require__.O(undefined, ["styles/gutenberg","styles/main"], function() { return __webpack_require__("./src/styles/main.scss"); })
var __webpack_exports__ = __webpack_require__.O(undefined, ["styles/gutenberg","styles/main"], function() { return __webpack_require__("./src/styles/gutenberg.scss"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
